import * as React from 'react'
import * as ReactDOM from 'react-dom/client'

import applyGlobalAxiosInterceptors, { API } from './app/configs/axios/axios.config'
import applyNotificationConfig from './app/configs/notification.config'
import createStore from './app/store/store'
import App from './app/app'
import { ConfigProvider } from 'antd'
import { colorText, primaryColor, secondaryTextColor } from './app/constants/styles'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

export const { store, persistor } = createStore()

const theme = {
    token: {
        colorText: colorText,
        colorTextSecondary: secondaryTextColor,
        colorTextTertiary: secondaryTextColor,
        colorTextQuaternary: secondaryTextColor,
        colorPrimary: primaryColor,
        colorLink: primaryColor,
        colorInfo: primaryColor,
        colorInfoText: primaryColor,
        colorSuccess: '#318500',
        colorSuccessText: '#318500',
        colorSuccessBg: 'rgba(92,255,0,0.05)',
        colorError: '#e10008',
        colorErrorText: '#e10008',
        colorErrorBg: 'rgba(163,25,30,0.05)',
    },
}

applyGlobalAxiosInterceptors(API)
applyNotificationConfig()

const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)

const render = () => {
    root.render(
        // <StrictMode>
        <ConfigProvider theme={theme}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <App store={store} />
                </PersistGate>
            </Provider>
        </ConfigProvider>,
        // </StrictMode>,
    )
}

render()
